// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "\r\n<div class=\"modal js-modal "
    + container.escapeExpression(alias1((depth0 != null ? depth0.classExtension : depth0), depth0))
    + "\" role=\"dialog\" aria-label=\"Pop up window\"><!-- default modal container/ creates overlay -->\r\n    <div class=\"modal-inner\"><!-- manages positioning of content -->\r\n        <div class=\"modal-inner-content js-modal-content\">\r\n            "
    + ((stack1 = alias1((depth0 != null ? depth0.content : depth0), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </div>\r\n</div>  ";
},"useData":true});
